import { render, staticRenderFns } from "./veHqWupinEdit.vue?vue&type=template&id=0650b872&scoped=true"
import script from "./veHqWupinEdit.vue?vue&type=script&lang=js"
export * from "./veHqWupinEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650b872",
  null
  
)

export default component.exports